import gql from 'graphql-tag';

export const GET_INVENTORY_BY_ID = gql`
  query GetInventoryById($input: InternalInventoryById!) {
    result: internalInventoryById(input: $input) {
      success
      error
      entity {
        id

        equipment {
          id

          assets {
            id
            source
          }

          price {
            retailPrice
            wholesaleCost
            totalWholesaleCost
          }

          details {
            make
            vin
            year
            model
            name
            class
            mileage
            stockId
            condition
            description
          }
        }
      }
    }
  }
`;
